import React, { useEffect, useMemo, useState } from 'react';
import { Button, Drawer, Input, Select, Space, theme } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import SortValueModal from './SortValueModal';

const Mobile = ({ viewModel }) => {
  const {
    value,
    option,
    valueLabelMap,
    sortModalOpen,
    draftOrder,
    handleSelectChange,
    openSortModal,
    applySortOrder,
    closeSortModal,
    reorderInDraft,
  } = viewModel;
  const { token } = theme.useToken();

  const [selectorOpen, setSelectorOpen] = useState(false);
  const [suppressOpen, setSuppressOpen] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [newValueText, setNewValueText] = useState('');
  const [draftSelected, setDraftSelected] = useState(value || []);

  useEffect(() => {
    setDraftSelected(value || []);
  }, [value]);

  const filteredValues = useMemo(() => {
    const keyword = String(searchKeyword || '').trim().toLowerCase();
    const allValues = option.values || [];
    if (!keyword) return allValues;
    return allValues.filter((item) => String(item?.title || '').toLowerCase().includes(keyword));
  }, [option.values, searchKeyword]);

  const toggleValue = (itemId) => {
    setDraftSelected((prev) => {
      const exists = prev.some((x) => String(x) === String(itemId));
      if (exists) {
        return prev.filter((x) => String(x) !== String(itemId));
      }
      return [...prev, itemId];
    });
  };

  const openSelector = () => {
    if (suppressOpen || selectorOpen) return;
    setDraftSelected([...(value || [])]);
    setSearchKeyword('');
    setSelectorOpen(true);
  };

  const closeSelector = () => {
    setSelectorOpen(false);
    setSuppressOpen(true);
    setTimeout(() => {
      setSuppressOpen(false);
    }, 180);
  };

  const onSelectMouseDown = (e) => {
    if (e?.target?.closest?.('.ant-select-selection-item-remove')) {
      setSuppressOpen(true);
      setTimeout(() => {
        setSuppressOpen(false);
      }, 180);
    }
  };

  const applySelector = async () => {
    await handleSelectChange(draftSelected);
    closeSelector();
  };

  const addNewValueFromMobile = async () => {
    const text = String(newValueText || '').trim();
    if (!text) return;
    await handleSelectChange([...(draftSelected || []), text]);
    setNewValueText('');
  };

  return (
    <>
      <Space direction='vertical' size={8} style={{ width: '100%' }}>
        <Select
          mode='multiple'
          open={false}
          style={{ width: '100%' }}
          placeholder={option.title || 'Chọn giá trị'}
          value={value}
          options={(option.values || []).map((v) => ({ value: v.id, label: v.title }))}
          onChange={handleSelectChange}
          onMouseDown={onSelectMouseDown}
          onClick={openSelector}
        />
      </Space>

      <Drawer
        title={option.title || 'Chọn giá trị'}
        open={selectorOpen}
        placement='bottom'
        height='80vh'
        onClose={closeSelector}
        footer={(
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button type='link' onClick={openSortModal} disabled={(draftSelected || []).length < 2}>
              Sắp xếp giá trị đã chọn
            </Button>
            <Button onClick={closeSelector}>Hủy</Button>
            <Button type='primary' onClick={applySelector}>Áp dụng</Button>
          </div>
        )}
      >
        <Space direction='vertical' size={10} style={{ width: '100%', height: '100%' }}>
          <Input
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            placeholder='Tìm giá trị...'
            allowClear
          />

          <Space.Compact style={{ width: '100%' }}>
            <Input
              value={newValueText}
              onChange={(e) => setNewValueText(e.target.value)}
              placeholder='Thêm giá trị mới'
              onPressEnter={addNewValueFromMobile}
            />
            <Button onClick={addNewValueFromMobile}>Thêm</Button>
          </Space.Compact>

          <div
            style={{
              flex: 1,
              minHeight: 200,
              overflowY: 'auto',
              border: `1px solid ${token.colorBorderSecondary}`,
              borderRadius: 8,
              background: token.colorBgContainer,
            }}
          >
            {filteredValues.map((item) => {
              const checked = draftSelected.some((x) => String(x) === String(item?.id));
              return (
                <div
                  key={String(item?.id)}
                  onClick={() => toggleValue(item?.id)}
                  style={{
                    padding: '10px 12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    background: token.colorBgContainer,
                    borderBottom: `1px solid ${token.colorBorderSecondary}`,
                  }}
                >
                  <span>{item?.title}</span>
                  <CheckOutlined style={{ color: token.colorPrimary, visibility: checked ? 'visible' : 'hidden' }} />
                </div>
              );
            })}
            {filteredValues.length === 0 && <div style={{ color: token.colorTextTertiary, padding: 12 }}>Không có giá trị phù hợp</div>}
          </div>
        </Space>
      </Drawer>

      <SortValueModal
        open={sortModalOpen}
        draftOrder={draftOrder}
        valueLabelMap={valueLabelMap}
        onCancel={closeSortModal}
        onApply={applySortOrder}
        onReorder={reorderInDraft}
      />
    </>
  );
};

export default Mobile;
